module.exports = __webpack_public_path__ + "static/media/data16.46680e15.ico";